export default "__VITE_ASSET__22553a73__"